{
  "title": "Purchase customers",
  "searchLabel": "Search by name, phone, vehicle number or type",
  "searchPlaceholder": "Search by name, phone, vehicle number or type...",
  "columns": {
    "name": "Name",
    "phone": "Phone number",
    "vehiclePlate": "Vehicle number",
    "vehicleType": "Vehicle type",
    "vehicleNationality": "Vehicle nationality",
    "driverNationality": "Driver nationality",
    "linkStatus": "Link status",
    "createdBy": "Added by",
    "createdAt": "Added at"
  },
  "fields": {
    "name": "Name",
    "phone": "Phone number",
    "vehiclePlate": "Vehicle number",
    "vehicleType": "Vehicle type",
    "vehicleNationality": "Vehicle nationality",
    "driverNationality": "Driver nationality",
    "phoneInvalid": "Invalid phone number"
  },
  "drawer": {
    "title": "Edit purchase customer",
    "phoneHint": "The number is saved only after checking that no other customer in any system has it"
  },
  "toasts": {
    "updated": "The purchase customer was updated"
  },
  "empty": {
    "noResults": "No results",
    "noData": "No data available"
  }
}
